import { createTheme, PaletteColor } from '@mui/material/styles';
import i18n from '../locale/i18n.ts';
import { Direction, PaletteMode } from '@mui/material';
import palettes from './colors.json';

declare module '@mui/material/styles' {
	interface Palette {
		green: keyof PaletteColor;
		orange: keyof PaletteColor;
	}
}

export default function useProjectTheme(theme: PaletteMode) {
	return createTheme({
		direction: i18n.t('_dir') as Direction,
		palette: {
			mode: theme,
			...palettes[theme],
		},
		typography: {
			fontFamily: 'PeydaWeb',
			fontSize: 12,
		},
		components: {
			MuiButton: {
				defaultProps: {
					variant: 'contained',
				},
			},
			MuiTextField: {
				defaultProps: {
					size: 'small',
				},
			},
			MuiFormLabel: {
				styleOverrides: {
					root: {
						display: 'flex !important', // Use flexbox
						flexDirection: 'row-reverse', // Reverse the row direction
						alignItems: 'center', // Align items vertically center
						gap: '4px',
					},
					asterisk: {
						color: palettes[theme].error.main, // Change the color of the asterisk
						fontSize: '20px', // Change the font size of the asterisk
						fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
						marginInlineStart: '-4px',
					},
				},
			},
		},
	});
}
